module.exports = __webpack_public_path__ + "static/media/3775.b0f8cb24.jpg";